import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { BounceLoader } from "react-spinners"; // Import the spinner
import { viewDoc } from "../../service/sharing";

const OtpEntryScreen = () => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const location = useLocation();
  const email = location.state?.email || "";
  const param = location.state?.param || "";

  const handleVerify = async () => {
    setResendMessage("");
    setLoading(true); // Start loading
    if (otp) {
      if (otp.length === 6) {
        try {
          const result = await viewDoc(param, { email, otp });

          if (result.privacy === "custom" && result.fileUrl) {
            window.open(result.fileUrl, "_self");
          } else if (result.message === "Wrong OTP") {
            setError("Invalid OTP");
          }
        } catch (error) {
          setError("Failed to validate OTP");
        }
      } else {
        setError("Please enter the correct OTP");
      }
    } else {
      setError("OTP cannot be empty");
    }
    setLoading(false); // Stop loading
  };

  const handleResendOtp = async () => {
    setLoading(true); // Start loading
    try {
      const result = await viewDoc(param, { email });
      setResendMessage("OTP has been resent to your email.");
      setError("");
    } catch (error) {
      setError("Failed to resend OTP");
    }
    setLoading(false); // Stop loading
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {loading ? (
          <div style={styles.loaderContainer}>
            <BounceLoader color="#000" />
          </div>
        ) : (
          <>
            <h2 style={styles.title}>Enter the OTP sent to {email}</h2>
            <div style={styles.inputContainer}>
              <input
                type="text"
                placeholder="OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={styles.input}
              />
            </div>
            {error && <p style={styles.error}>{error}</p>}
            {resendMessage && (
              <p style={styles.resendMessage}>{resendMessage}</p>
            )}
            <button onClick={handleVerify} style={styles.button}>
              Verify
            </button>
            <button onClick={handleResendOtp} style={styles.resendButton}>
              Resend OTP
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f0f2f5",
    padding: "16px",
  },
  card: {
    backgroundColor: "#fff",
    padding: "32px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    maxWidth: "400px",
    width: "100%",
  },
  title: {
    marginBottom: "24px",
    fontSize: "24px",
    color: "#333",
    fontFamily: "Arial, sans-serif",
  },
  inputContainer: {
    position: "relative",
    marginBottom: "16px",
  },
  input: {
    padding: "12px 20px",
    fontSize: "16px",
    width: "100%",
    borderRadius: "20px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.3s ease",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    marginBottom: "12px",
  },
  error: {
    color: "red",
    fontSize: "14px",
    marginBottom: "16px",
  },
  resendMessage: {
    color: "green",
    fontSize: "14px",
    marginBottom: "16px",
  },
  button: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "black",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    marginTop: "12px",
    marginRight: "10px",
  },
  resendButton: {
    padding: "12px 24px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "black",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    marginTop: "16px",
  },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
};

export default OtpEntryScreen;
